import { render, staticRenderFns } from "./recordnew.vue?vue&type=template&id=23426027&scoped=true&"
import script from "./recordnew.vue?vue&type=script&lang=js&"
export * from "./recordnew.vue?vue&type=script&lang=js&"
import style0 from "./recordnew.vue?vue&type=style&index=0&id=23426027&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23426027",
  null
  
)

export default component.exports